import React from 'react';
import classnames from 'classnames';
import styles from './RoundedGoBackButton.scss';
import Button from './Button';
const RoundedGoBackButton = ({ additionClasses, ...props }) => (<Button additionClasses={classnames(additionClasses, 'btn-rounded', styles.goBackStyle)} type="button" {...props}/>);
export default RoundedGoBackButton;
